document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".tw-audio-player").forEach(function (player) {
    const id = player.dataset.audioId;
    const audio = document.getElementById("audio-" + id);
    const playBtn = player.querySelector(".tw-play-btn");
    const progress = player.querySelector(".tw-progress");
    const currentDisplay = player.querySelector(".tw-current");
    const durationDisplay = player.querySelector(".tw-duration");

    function formatTime(s) {
      if (isNaN(s)) return "0:00";
      const m = Math.floor(s / 60);
      return m + ":" + String(Math.floor(s % 60)).padStart(2, "0");
    }

    // ✅ Show end/duration time once metadata loads
    audio.addEventListener("loadedmetadata", function () {
      durationDisplay.textContent = formatTime(audio.duration);
    });

    // Update current time & progress bar while playing
    audio.addEventListener("timeupdate", function () {
      currentDisplay.textContent = formatTime(audio.currentTime);
      if (audio.duration) {
        progress.value = (audio.currentTime / audio.duration) * 100;
      }
    });

    // Play/Pause button
    playBtn.addEventListener("click", function () {
      // Pause all other players first
      document.querySelectorAll(".tw-audio").forEach(function (a) {
        if (a !== audio) {
          a.pause();
          const otherPlayer = a.closest(".tw-audio-player");
          if (otherPlayer) {
            otherPlayer.querySelector(".tw-play-btn").textContent = "▶";
          }
        }
      });

      if (audio.paused) {
        audio.play();
        playBtn.textContent = "⏸";
      } else {
        audio.pause();
        playBtn.textContent = "▶";
      }
    });

    // Seek via range slider
    progress.addEventListener("input", function () {
      if (audio.duration) {
        audio.currentTime = (progress.value / 100) * audio.duration;
      }
    });

    // Reset on end
    audio.addEventListener("ended", function () {
      playBtn.textContent = "▶";
      progress.value = 0;
      currentDisplay.textContent = "0:00";
    });
  });
});

// Variant Change Image Filtering
let savedScrollPositions = new Map();

document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        // Save scroll positions before variant change re-render
        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
            const wrappers = document.querySelectorAll('.tw-variant-scroll-wrapper');
            wrappers.forEach((wrapper, index) => {
                savedScrollPositions.set(index, wrapper.scrollLeft);
            });
        });

        // Handle variant change effects
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
            // Restore scroll positions
            const wrappers = document.querySelectorAll('.tw-variant-scroll-wrapper');
            wrappers.forEach((wrapper, index) => {
                if (savedScrollPositions.has(index)) {
                    wrapper.scrollLeft = savedScrollPositions.get(index);
                }
                
                // Also ensure active label is visible
                const activeLabel = wrapper.querySelector('input:checked + label');
                if (activeLabel) {
                    activeLabel.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
                }
            });

            imageFiltered(variant);
            imageFilteredMob(variant);
            console.log("variant changed", variant);
        });
    }
    initVariantLogic();
});

function initVariantLogic() {
    const variantScript = document.querySelector('script[data-selected-variant]');
    if (variantScript) {
        try {
            const variant = JSON.parse(variantScript.textContent);
            if (variant) {
                imageFiltered(variant);
                imageFilteredMob(variant);
            }
        } catch (e) {
            console.error("Error parsing initial variant", e);
        }
    }
}

document.addEventListener('shopify:section:load', initVariantLogic);

function imageFiltered(newVariant) {
    let variantObject = newVariant || null;
    if (!variantObject) {
        const mediaContainer = document.querySelectorAll('.thumbnail img');
        mediaContainer.forEach(img => {
            const li = img.closest('li');
            if (li) li.classList.remove('hidden-variant');
        });
        return;
    }

    let variantTitle = variantObject.title;
    if (variantTitle) {
        const variantParts = variantTitle
            .toLowerCase()
            .split(' / ')
            .map(part => part.trim());

        const mediaContainer = document.querySelectorAll('.thumbnail img');
        let matched = false;

        mediaContainer.forEach(img => {
            const productFeatImage = img.closest('li');
            if (!productFeatImage) return;

            const imgAlt = img.alt ? img.alt.toLowerCase().trim() : '';

            if (!imgAlt) {
                productFeatImage.classList.remove('hidden-variant');
                return;
            }

            console.log('variantParts:', variantParts, '| imgAlt:', imgAlt);
            const isMatch = variantParts.some(part => part === imgAlt);

            productFeatImage.classList.toggle('hidden-variant', !isMatch);
            if (isMatch) matched = true;
        });

        if (!matched && variantTitle !== 'Default Title') {
            console.log("no matched alt text - showing all");
            mediaContainer.forEach(img => {
                const li = img.closest('li');
                if (li) li.classList.remove('hidden-variant');
            });
        }
    }
}

function imageFilteredMob(newVariant) {
    let variantObjectMob = newVariant || null;
    if (!variantObjectMob) {
        const mediaContainerMob = document.querySelectorAll('.product__media img');
        mediaContainerMob.forEach(img => {
            const li = img.closest('li');
            if (li) li.classList.remove('hidden-variant');
        });
        return;
    }

    let variantTitleMob = variantObjectMob.title;
    if (variantTitleMob) {
        const variantPartsMob = variantTitleMob
            .toLowerCase()
            .split(' / ')
            .map(part => part.trim());

        const mediaContainerMob = document.querySelectorAll('.product__media img');
        let matched = false;

        mediaContainerMob.forEach(img => {
            const productFeatImageMob = img.closest('li');
            if (!productFeatImageMob) return;

            const imgAltMob = img.alt ? img.alt.toLowerCase().trim() : '';

            if (!imgAltMob) {
                productFeatImageMob.classList.remove('hidden-variant');
                return;
            }

            console.log('variantPartsMob:', variantPartsMob, '| imgAltMob:', imgAltMob);
            const isMatch = variantPartsMob.some(part => part === imgAltMob);

            productFeatImageMob.classList.toggle('hidden-variant', !isMatch);
            if (isMatch) matched = true;
        });

        if (!matched && variantTitleMob !== 'Default Title') {
            console.log("no matched alt text - showing all");
            mediaContainerMob.forEach(img => {
                const li = img.closest('li');
                if (li) li.classList.remove('hidden-variant');
            });
        }
    }
}
function runInitialVariant() {
  const variantNode = document.querySelector('variant-selects [data-selected-variant]');
  
  if (!variantNode) return;

  try {
    const variant = JSON.parse(variantNode.textContent);

    console.log('Initial variant:', variant);

    imageFiltered(variant);
    imageFilteredMob(variant);
  } catch (e) {
    console.error('Variant parse error', e);
  }
}
function initVariantLogic() {
  runInitialVariant();

  if (!window.variantListenerAttached) {
    window.variantListenerAttached = true;

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
      imageFiltered(variant);
      imageFilteredMob(variant);
      console.log("variant changed", variant);
    });
  }
}

// Run immediately
initVariantLogic();

// Handle Shopify section reload
document.addEventListener('shopify:section:load', initVariantLogic);
document.addEventListener('DOMContentLoaded', () => {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
      imageFiltered(variant);
      imageFilteredMob(variant);
      console.log("variant changed", variant);
  });
});